<pagination [totalItems]="88" [(ngModel)]="currentPage" (numPages)="smallnumPages = $event"></pagination>

<pre class="card card-block card-header mb-3">The selected page no: {{currentPage}}/{{smallnumPages}}</pre>
